var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { staticClass: "grid-list-md pa-0 mb-5" },
    [
      _c(
        "v-flex",
        { staticClass: "text-xs-right", attrs: { xs12: "" } },
        [
          _c(
            "v-tooltip",
            { attrs: { disabled: !_vm.showTooltip, top: "" } },
            [
              _c(
                "v-btn",
                {
                  staticStyle: { "margin-bottom": "-6px" },
                  attrs: { slot: "activator", round: "", color: "secondary" },
                  on: { click: _vm.addMedicaidRecord },
                  slot: "activator"
                },
                [
                  _c("v-icon", { attrs: { dark: "" } }, [_vm._v("mdi-plus")]),
                  _vm._v("\n        Add Procedure\n      ")
                ],
                1
              ),
              _vm._v(" "),
              _c("span", [_vm._v("Add procedure")])
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm._l(_vm.student.form.medicaid, function(record, index) {
        return _c(
          "v-flex",
          { key: index, attrs: { xs12: "" } },
          [
            _c("medicaid-repeatable", {
              attrs: {
                v: _vm.v,
                student: _vm.student,
                medicaidArray: _vm.medicaidArray,
                showTooltip: _vm.showTooltip,
                index: index,
                record: record
              },
              on: {
                "delete:record": function($event) {
                  return _vm.removeMedicaidRecord(index)
                },
                "calculate:minutes": _vm.calculateMinutes
              }
            })
          ],
          1
        )
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5be8c946", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5be8c946","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/service-log/form/medicaid-information.vue
// module id = null
// module chunks = 